import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAdminRole } from '../../hooks/useAdminRole';
import { useSwapHighlight } from '../../hooks/useSwapHighlight';
import Icon from '../common/Icon';

const BottomNav = () => {
  const role = useAdminRole();
  const swapGlow = useSwapHighlight();

  const items = [
    { to: '/',       label: 'Home',   icon: 'home',   exact: true },
    { to: '/invest', label: 'Invest', icon: 'invest' },
    { to: '/team',   label: 'Team',   icon: 'team' },
    { to: '/ranks',  label: 'Rank',   icon: 'rank' },
    { to: '/swap',   label: 'Swap',   icon: 'swap' },
  ];
  if (role.isPrivileged) items.push({ to: '/admin', label: 'Admin', icon: 'admin' });

  return (
    <nav className="bottom-nav" style={{ '--bn-cols': items.length }}>
      <div className="bottom-nav-inner">
        {items.map((it) => {
          const extra = (it.to === '/swap' && swapGlow) ? ' highlighted' : '';
          return (
            <NavLink
              key={it.to}
              to={it.to}
              end={it.exact}
              className={({ isActive }) => 'bn-item' + (isActive ? ' active' : '') + extra}
            >
              <Icon name={it.icon} size={20} className="bn-icon-svg" />
              <span>{it.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
